import * as Sentry from "@sentry/vue";
import type { App } from "vue";
import type { Router } from "vue-router";

export function initializeSentry(app: App, envVariables: any, router?: Router) {
  if (
    envVariables.VITE_SENTRY_DSN &&
    envVariables.VITE_ENVIRONMENT !== "review"
  ) {
    if (router) {
      const integrations = [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        }),
      ];
    }

    Sentry.init({
      app,
      environment: envVariables.VITE_ENVIRONMENT,
      dsn: envVariables.VITE_SENTRY_DSN,
      release: envVariables.VITE_RELEASE_TAG,
      tracesSampleRate: 0.2,
      tracePropagationTargets: ["localhost", /api\/v1/],
      allowUrls: ["stopsmoking.ch"],
    });
  }
}

/** Severity for {@link captureException}; mirrors Sentry's levels. */
export type CaptureLevel = "fatal" | "error" | "warning" | "info" | "debug";

/**
 * Report a non-fatal exception with optional tags/level, so feature code can
 * surface errors to Sentry without importing the SDK directly. No-ops when
 * Sentry was never initialised (no DSN configured). Used by the offline sync
 * layer to capture replay failures and storage-quota errors (REL-900).
 */
export function captureException(
  error: unknown,
  context?: { tags?: Record<string, string>; level?: CaptureLevel },
): void {
  Sentry.captureException(error, {
    tags: context?.tags,
    level: context?.level ?? "error",
  });
}

export function getSentryVitePluginConfig(
  projectName: string,
  envVariables: any,
) {
  return {
    org: "liip-qq",
    project: projectName,
    authToken: envVariables.VITE_SENTRY_AUTH_TOKEN,
  };
}
